import React from 'react';
import { Form } from 'semantic-ui-react';
import PhoneInput from '../../../../../../components/PhoneInput';
import './RequesterInformation.css';
var defaultProps = {
  name: '',
  email: '',
  phone: '',
  show: true
};
export default function RequesterInformation(_ref) {
  var onFieldChange = _ref.onFieldChange,
      show = _ref.show,
      name = _ref.name,
      email = _ref.email,
      phone = _ref.phone;

  if (!show) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: "header-text extra-margin"
  }, "Requester Info"), /*#__PURE__*/React.createElement(Form.Input, {
    value: name || '',
    label: "Name",
    name: "name",
    required: true,
    onChange: onFieldChange
  }), /*#__PURE__*/React.createElement(Form.Input, {
    value: email || '',
    label: "Email",
    name: "email",
    required: true,
    placeholder: "you@gmail.com",
    type: "email",
    onChange: onFieldChange
  }), /*#__PURE__*/React.createElement(Form.Input, {
    label: "Mobile Phone Number",
    required: true
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    required: true,
    onChange: onFieldChange,
    name: "phone",
    value: phone || ''
  })));
}
RequesterInformation.defaultProps = defaultProps;